import { useState ,useEffect} from "react";
import Div from "@jumbo/shared/Div";
import Card from "@mui/material/Card";
import Backdrop from "@mui/material/Backdrop";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axios_public } from "../../../axios";
import { Info } from "@mui/icons-material";
import ExpiryLinkModal from "./components/ExpiryLinkModal";
import MessageDisplayModal from "./components/MessageDisplayModal";
import {toast} from "react-toastify";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Tooltip from "@mui/material/Tooltip";


const TenantUserInvite = () => {
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [pageLoading,setPageLoading] = useState(true);
    const [loading,setLoading] = useState(false);
    const [openModal,setOpenModal] = useState(false);
    const [openDisplay,setOpenDisplay] = useState(false);
    const [passPolicy, setPassPolicy] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepassword, setShowRepassword] = useState(false);
    const [expired,setExpired] = useState(false);
    const initialState = {
        fname: "",
        lname: "",
        email: searchParams.get("email"),
        password: "",
        repassword: ""
    };
    const [parameters, setParameters] = useState(initialState);
    const { fname, lname, email, password, repassword } = parameters;

    useEffect(() => {
        checkLinkExpiry();
    }, []);

    const handleChange = e => {
        e.preventDefault();
        setParameters({ ...parameters, [e.target.id]: e.target.value });
    };

    const checkLinkExpiry = () =>{
        axios_public
            .post("/tenantAPI/user/checkLinkExpiry", {email: searchParams.get("email")}, {
                headers : {
                    "X-Expiry-Token": searchParams.get("token")
                }
            })
            .then((res)=>{
                if (!(res?.data?.link_valid)){
                    setExpired(res?.data?.message || "");
                    setOpenModal(true);
                }
            })
            .catch((err)=>{
            })
            .finally(() => {
                setPageLoading(false);
            });
    }

    const handleSubmit = e => {
        e.preventDefault();
        setLoading(true);

        if (!fname || !lname || !email || !password || !repassword) {
            toast.error("Please fill all the fields");
            setLoading(false);
            return;
        }
        
        axios_public
            .post("/tenantAPI/user/acceptInvitation", parameters)
            .then(res => {
                setLoading(false);
                localStorage.removeItem("TENANT_NAME");
                localStorage.removeItem("TENANT_USER_ID");
                localStorage.removeItem("TREXO_TENANT_AUTH_TOKEN");
                localStorage.removeItem("tenant_username");
                localStorage.removeItem("TENANT_USER_MAIL");
                localStorage.removeItem("TENANT_ROLE");
                localStorage.removeItem("ICON");
                navigate("/login");
            })
            .catch(err => {
                setLoading(false);
            });
    };

    return (
        expired?(<Div sx={{
            flex: 1,
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop:"10%",
            p: theme => theme.spacing(4),
        }}>
            <Typography align={"center"} component={"h2"} variant={"heading"} color={"red"} mb={3}>
                <ExpiryLinkModal open={openModal} setOpen={setOpenModal} displayMessage={expired} setOpenDisplay={setOpenDisplay}/>
                {openDisplay && <MessageDisplayModal openDisplay={openDisplay}/>}
            </Typography>
        </Div>) :
         (pageLoading ?
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 1300,
                    backgroundColor: "rgba(0,0,0,0.4)",
                }}
                open={open}
            >
                <CircularProgress size={60} thickness={4.5} />
            </Backdrop> :
            <Div
                sx={{
                    width: 720,
                    maxWidth: "100%",
                    margin: "auto",
                    marginTop:"3%",
                    p: 4
                }}
            >
                <Card
                    sx={{
                        display: "flex",
                        minWidth: 0,
                        flexDirection: { xs: "column", md: "row" },
                        background : "#FFF"
                    }}
                >
                    <CardContent
                        sx={{
                            flex: "0 1 300px",
                            position: "relative",
                            background: "#010160",
                            backgroundSize: "cover",

                            "&::after": {
                                display: "inline-block",
                                position: "absolute",
                                content: `''`,
                                inset: 0,
                                backgroundColor: alpha("#010160", 0.65)
                            }
                        }}
                    >
                        <Div
                            sx={{
                                display: "flex",
                                minWidth: 0,
                                flex: 1,
                                flexDirection: "column",
                                color: "common.white",
                                position: "relative",
                                zIndex: 1,
                                height: "100%"
                            }}
                        >
                            <Div sx={{ mb: 2 }}>
                                <Typography variant={"h3"} color={"white"} fontWeight={300} mb={3}>
                                    Accept Invitation
                                </Typography>
                                <Typography variant={"body1"} mb={2}></Typography>
                            </Div>
                        </Div>
                    </CardContent>
                    <CardContent
                        sx={{
                            flex: 1,
                            p: 4
                        }}
                    >
                        <Div sx={{ display: "flex",justifyContent: "center", alignItems: "center",mt: "auto",mb: 4}}>
                            <img src={"/images/logo.png"} alt="" style={{maxWidth: "100%", objectFit: "contain"}}/>
                        </Div>
                        <Div sx={{ mt: 1, mb: 3 }}>
                            <TextField fullWidth id="fname" label="First Name" required value={fname} onChange={handleChange} autoComplete="off" />
                        </Div>
                        <Div sx={{ mt: 1, mb: 3 }}>
                            <TextField fullWidth id="lname" label="Last Name" required value={lname || ""} onChange={handleChange} autoComplete="off" />
                        </Div>
                        <Div sx={{ mt: 1, mb: 3 }}>
                            <TextField fullWidth id="email" label="Email" disabled value={searchParams.get("email")} onChange={handleChange} autoComplete="off" />
                        </Div>
                        <Div sx={{ mt: 1, mb: 2 }}>
                            <TextField
                                fullWidth id="password" label="Password" type={showPassword ? "text" : "password"}
                                value={password} required onChange={handleChange} autoComplete="new-password"
                                InputProps={{ endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title={showPassword ? "Hide password" : "Show password"}>
                                            <IconButton type="button" edge="end" aria-label={showPassword ? "Hide password" : "Show password"}
                                                onMouseDown={event => event.preventDefault()} onClick={() => setShowPassword(value => !value)}>
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                ) }}
                            />
                        </Div>
                        <Div sx={{ mt: 1, mb: 2 }}>
                            <TextField
                                fullWidth id="repassword" label="Re-enter Password" type={showRepassword ? "text" : "password"}
                                value={repassword} required onChange={handleChange} autoComplete="new-password"
                                InputProps={{ endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title={showRepassword ? "Hide password" : "Show password"}>
                                            <IconButton type="button" edge="end" aria-label={showRepassword ? "Hide password" : "Show password"}
                                                onMouseDown={event => event.preventDefault()} onClick={() => setShowRepassword(value => !value)}>
                                                {showRepassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                ) }}
                            />
                        </Div>

                        <Div sx={{ mt: 1, mb: 2, fontSize: 12 }}>
                            Password Guidelines <Info onClick={() => setPassPolicy(!passPolicy)} />
                        </Div>
                        {passPolicy && (
                            <div>
                                <ul style={{ fontSize: 12 }}>
                                    <li>At least 8 character long</li>
                                    <li>One upper case letter (A-Z)</li>
                                    <li>One lower case letter (a-z)</li>
                                    <li>Contains at least One numeric digit (0-9)</li>
                                    <li> Contains at least one special character, i.e. ( ! @ # ? )</li>
                                    <li>Should not contain username in password</li>
                                </ul>
                            </div>
                        )}
                        <Button type="submit" variant="contained" sx={{ mb: 2 }} onClick={handleSubmit} disabled={loading || !fname || !lname || !email || !password || !repassword}>
                            {loading  ? <CircularProgress size={25} sx={{ color: "blue" }} /> : <span>Signup</span>}
                        </Button>
                    </CardContent>
                </Card>
            </Div>)
    );
};



export default TenantUserInvite;
